module.exports = __webpack_public_path__ + "static/media/Clefairy_gaussian2.4289e32e.png";